const cep = (value, optional) => {
  if (optional && (value === '' || !value)) {
    return true
  }
  if (!/^[0-9]{5}-?[0-9]{3}$/.test(value)) return false
  return true
}

export { cep }
export default { cep }
